module.exports = __webpack_public_path__ + "static/foto-20-19540b8015fb00e699e2b9724bb55206.png";